import { useEffect, useRef } from 'react';
import { Luminous, LuminousGallery } from 'luminous-lightbox';

type Props = {
  children: React.ReactNode;
};

export const LuminousGalleryWrapper = ({ children }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const triggers = containerRef.current.querySelectorAll('.luminous');

    if (triggers.length === 1) {
      new Luminous(triggers[0] as HTMLElement);
      return;
    }

    if (triggers.length > 1) {
      new LuminousGallery(triggers);
    }
  }, []);

  return <div ref={containerRef}>{children}</div>;
};
